import OtpInput from "react-otp-input";

// Drop-in replacement for react-otp-input that only accepts digits: typed and
// pasted non-digits are stripped, mobile shows the number pad, and browsers /
// password managers can autofill SMS codes. Pass `renderInput` to customise
// the <input> (e.g. type="password" for PINs) — the numeric props still apply.
const NumericOtpInput = ({ onChange, renderInput, ...props }) => (
  <OtpInput
    {...props}
    inputType="tel"
    onChange={(value) => onChange(String(value).replace(/\D/g, ""))}
    renderInput={(inputProps, index) => {
      const numericProps = {
        ...inputProps,
        inputMode: "numeric",
        pattern: "[0-9]*",
        autoComplete: "one-time-code",
      };
      return renderInput ? (
        renderInput(numericProps, index)
      ) : (
        <input {...numericProps} />
      );
    }}
  />
);

export default NumericOtpInput;
